module.exports = __webpack_public_path__ + "img/maps-and-location.2318612e.webp";